function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import EditorWithChangeHighlights from './EditorWithChangeHighlights';
import { Editor } from '@tinymce/tinymce-react';
import { apiKey } from '@rd-web-markets/shared/dist/util/tinyMceConfig';
import React, { memo } from 'react';
export default /*#__PURE__*/memo(function ReviewableFieldEditor(_ref) {
  let {
    isUnderReview,
    focusOnInit = true,
    editorContent,
    editorInitConfig,
    // Accepts onCreateComment callback as an argument and calls a config function, passing the callback.
    // The config function returns the editor init config.
    trackChangesEditoInitFn,
    trackChangesOnCreateComment,
    onEditorChange,
    modelClass,
    modelId,
    modelField,
    showTrackChangesControls,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, isUnderReview && /*#__PURE__*/React.createElement(EditorWithChangeHighlights, _extends({
    focusOnInit: focusOnInit,
    editorContent: editorContent,
    onEditorChange: onEditorChange,
    modelClass: modelClass,
    modelId: modelId,
    modelField: modelField,
    onCreateComment: trackChangesOnCreateComment,
    editorWithHighlightsConfig: trackChangesEditoInitFn,
    showTrackChangesControls: showTrackChangesControls
  }, props)), !isUnderReview && /*#__PURE__*/React.createElement(Editor, _extends({
    apiKey: apiKey,
    value: editorContent,
    name: "body",
    onEditorChange: onEditorChange,
    init: editorInitConfig
  }, props)));
});